
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from "react-router";

import { RootState } from '../../store';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { SearchTextField } from "../../components/SearchTextField";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ActualizarSexo, AgregarSexo, Sexo } from "../../connections/catalogos/SexoConnection";

import { SexoProps } from "../../interfaces/catalogos/SexoInterface";

export const SexoPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador } = useSelector( ( state: RootState ) => state.auth );

    const [SexoArray, setSexoArray] = useState<SexoProps[]>( [] );
 
    const [openModal, setOpenModal] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idSexo, setIdSexo] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );
    const [abreviacion, setAbreviacion] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( SexoArray, ( item, filtro ) => item.descripcion.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const SexoSelected = SexoArray.find( ( elem ) => elem.idSexo === id );

        if( SexoSelected ){

            await ActualizarSexo({ ...SexoSelected, activo: checked }).then( resp => {
                
                if( resp.idSexo ){

                    var newArray = SexoArray.map( ( elem ) => {

                    if( elem.idSexo === id ){
                        elem.activo = checked;
                    }
            
                        return elem;
                    });
            
                    setSexoArray( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 
                }    
    
            });
        }       

    }

    const handleGuardar = async () => {

        if( idSexo !== 0 ){

            const SexoSelected = SexoArray.find( ( elem ) => elem.idSexo === idSexo );

            if( SexoSelected ){

                setLoading( true );
    
                await ActualizarSexo({ ...SexoSelected, descripcion, }).then( resp => {
                    
                    if( resp.idSexo ){

                        setTimeout(() => {
                            
                            var newArray = SexoArray.map( ( elem ) => {
        
                                if( elem.idSexo === idSexo ){
                                    elem.descripcion = descripcion;
                                    elem.abreviacion = abreviacion;
                                }
                        
                                return elem;
                            });
                    
                            setSexoArray( newArray );
                            setOpenModal( false );
                            setLoading( false );
                            
                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                        }, 700);
    
                    }    
        
                });
            }       
    

        }
        else {

            const SexoAdd: SexoProps = {
                idSexo: 0,
                descripcion,               
                activo: true,
                abreviacion
            }

            setLoading( true );

            await AgregarSexo( SexoAdd ).then( resp => {
                    
                if( resp.idSexo ){                
            
                    setTimeout(() => {
                        
                        setSexoArray([ ...SexoArray, resp ]);
                        setOpenModal( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó el sexo correctamente', variant: 'success' })); 

                    }, 700);

                }    
    
            });

        }

    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setSexoArray( [] );

            await Sexo().then( resp => {

                setTimeout(() => {
                    
                    setSexoArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])    

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Sexo' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ xs: 6 }} textAlign={'start'}>
                    {
                        administrador
                        &&
                            <Button startIcon={ <UndoIcon /> } color="secondary" variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }
                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>
                    <Button
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdSexo( 0 );
                            setDescripcion( '' );
                            setAbreviacion( '' )
                            setOpenModal( true );
                        }}
                    >
                        Agregar
                    </Button>
                </Grid>

            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }} textAlign={'start'}>
                    <SearchTextField
                        value={ filtro }
                        label="Buscar sexo"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />
                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'35%' }}> Descripción </TableCell>                                     
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'35%' }}> Abreviación </TableCell>                                     
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ? 
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                : 
                                    dataFiltrada
                            )
                            .map( ( { idSexo, descripcion, activo , abreviacion } ) => (

                                <TableRow key={ idSexo} >
                                
                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        { idSexo }
                                    </TableCell>                                 

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>      

                                    <TableCell>
                                        { abreviacion }
                                    </TableCell>      
    
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idSexo ) }
                                        />
                                 
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {

                                                    setIdSexo( idSexo );
                                                    setDescripcion( descripcion );                                                   
                                                    setAbreviacion( abreviacion )
                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  

                                    </TableCell>

                                </TableRow>

                            ))
                        }                    
            
                        { 
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> 
                                            Total de registros: { dataFiltrada.length } 
                                        </Typography>
                                    </TableCell> 

                                    <TablePagination  
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ dataFiltrada.length }                                        
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>
                        }

                    </TableFooter>
                    
                </Table>
                
            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
            
                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={3} sx={{ mt: 3 }}>
                        
                        <Grid size={{ md: 6, xs: 12 }}>
                            <TextField                        
                                fullWidth                                                        
                                label={ 'Descripción'}
                                variant="outlined"                           
                                value={ descripcion }
                                onChange={ (e) => setDescripcion( e.target.value ) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }} 
                            /> 
                        </Grid>
                        
                        <Grid size={{ md: 6, xs: 12 }}>
                            <TextField
                                fullWidth
                                label={ 'Abreviación'}
                                variant="outlined"                           
                                value={ abreviacion }
                                onChange={ (e) => setAbreviacion( e.target.value ) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }} 
                            /> 
                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={ loading } onClick={ () => setOpenModal( false ) }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' || abreviacion === "" } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}